<template>
  <div class="columns is-mobile is-centered">
    <div
      class="column is-full-mobile is-four-fifths-tablet is-two-thirds-desktop is-two-thirds-widescreen is-two-thirds-fullhd"
    >
      <div class="card mt-5">
        <div class="card-content">
          <p class="title has-text-weight-medium">Customer Contact</p>
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label has-text-weight-medium">Name</label>
            </div>
            <div class="field-body">
              <div class="field">
                <p class="control is-expanded">
                  <input
                    :class="['input',errors.firstName? 'is-danger': '']"
                    type="text"
                    placeholder="First name"
                    v-model="customerInfo.contactInfo.name.firstName"
                    maxlength="100"
                  />
                </p>
                <p class="help is-danger" v-if="errors.firstName">{{errors.firstName.msg}}</p>
              </div>
              <div class="field">
                <p class="control is-expanded">
                  <input
                    :class="['input',errors.lastName? 'is-danger': '']"
                    type="text"
                    placeholder="Last name"
                    v-model="customerInfo.contactInfo.name.lastName"
                    maxlength="100"
                  />
                </p>
                <p class="help is-danger" v-if="errors.lastName">{{errors.lastName.msg}}</p>
              </div>
            </div>
          </div>
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label has-text-weight-medium">Phone number</label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control has-icons-left">
                  <input
                    :class="['input',errors.phoneNumber? 'is-danger': '']"
                    type="tel"
                    placeholder="Your phone number"
                    v-model="customerInfo.contactInfo.phoneNumber"
                    maxlength="10"
                    required
                    :disabled="disableCustomerPhoneNumber === true"
                  />
                  <span class="icon is-small is-left">
                    <font-awesome-icon icon="phone" />
                  </span>
                </div>
                <p class="help is-danger" v-if="errors.phoneNumber">{{errors.phoneNumber.msg}}</p>
              </div>
            </div>
          </div>
          <template v-if="deliveryInfo && deliveryInfo.mode === 'Delivery'">
            <p class="title has-text-weight-medium mt-5">Delivery Information</p>
            <div class="subtitle">
              <span class="mr-5">Delivery Location</span>
              <span
                v-if="user.deliveryInfos && user.deliveryInfos.length > 0"
                class="select is-size-6 is-pulled-right"
              >
                <select v-on:change="onDeliveryInfoLabelChange">
                  <option value>New</option>
                  <option
                    v-for="info in user.deliveryInfos"
                    :key="info.id"
                    :value="info.id"
                  >{{info.label}}</option>
                </select>
              </span>
            </div>
            <AddressPicker
              v-bind:mapConfig="mapConfig"
              v-bind:defaultAddress="deliveryInfo.address"
              v-on:addressChanged="onDeliveryAddressChange"
            />
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label has-text-weight-medium">Label</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control is-expanded">
                    <input
                      :class="['input',errors.deliveryInfoLabel? 'is-danger': '']"
                      type="text"
                      placeholder="e.g. Home, Work etc."
                      v-model="deliveryInfo.label"
                      maxlength="25"
                    />
                  </p>
                  <p
                    class="help is-danger"
                    v-if="errors.deliveryInfoLabel"
                  >{{errors.deliveryInfoLabel.msg}}</p>
                </div>
              </div>
            </div>
            <p class="subtitle">Delivery Contact</p>
            <div class="field">
              <div class="field-body">
                <label class="checkbox">
                  <input type="checkbox" :checked="useCustomerContact" v-on:click="copyContactInfo" />
                  Same as customer contact
                </label>
              </div>
            </div>
            <template v-if="!useCustomerContact">
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label has-text-weight-medium">Name</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <p class="control is-expanded">
                      <input
                        :class="['input',errors.deliveryInfoFirstName? 'is-danger': '']"
                        type="text"
                        placeholder="First name"
                        v-model="deliveryInfo.contactInfo.name.firstName"
                      />
                    </p>
                    <p
                      class="help is-danger"
                      v-if="errors.deliveryInfoFirstName"
                    >{{errors.deliveryInfoFirstName.msg}}</p>
                  </div>
                  <div class="field">
                    <p class="control is-expanded">
                      <input
                        :class="['input',errors.deliveryInfoLastName? 'is-danger': '']"
                        type="text"
                        placeholder="Last name"
                        v-model="deliveryInfo.contactInfo.name.lastName"
                      />
                    </p>
                    <p
                      class="help is-danger"
                      v-if="errors.deliveryInfoLastName"
                    >{{errors.deliveryInfoLastName.msg}}</p>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label has-text-weight-medium">Phone number</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control has-icons-left">
                      <input
                        :class="['input', errors.deliveryInfoPhoneNumber? 'is-danger': '']"
                        type="tel"
                        placeholder="Your phone number"
                        v-model="deliveryInfo.contactInfo.phoneNumber"
                        maxlength="10"
                        required
                      />
                      <span class="icon is-small is-left">
                        <font-awesome-icon icon="phone" />
                      </span>
                    </div>
                    <p
                      class="help is-danger"
                      v-if="errors.deliveryInfoPhoneNumber"
                    >{{errors.deliveryInfoPhoneNumber.msg}}</p>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <p class="help is-danger" v-if="errors.deliveryInfoFirstName">{{errors.deliveryInfoFirstName.msg}}</p>
              <p class="help is-danger" v-if="errors.deliveryInfoLastName">{{errors.deliveryInfoLastName.msg}}</p>
              <p class="help is-danger" v-if="errors.deliveryInfoPhoneNumber">{{errors.deliveryInfoPhoneNumber.msg}}</p>
            </template>
          </template>
          <template v-if="!resourceId && features.allowPreOrder">
            <p class="title has-text-weight-medium mt-5">Order Schedule</p>
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label has-text-weight-medium lineheight-medium">{{ deliveryModeLabel }} by</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="help is-warn mb-5" v-if="!deliveryDate && business.deliveryTime">{{ scheduledDeliveryHint }}</p>
                  <p class="control is-expanded">
                    <date-pick
                      v-model="deliveryDate"
                      :pickTime="true"
                      :use12HourClock="true"
                      :format="'YYYY-MM-DD HH:mm'"
                      :displayFormat="'DD/MM H:mm A'"
                      :isDateDisabled="isPastDate"
                      :selectableYearRange="{from: 2020}"
                      :class="[errors.preorderDate? 'is-danger': '']"
                    >
                    <template v-slot:default="{toggle}">
                      <div class="buttons">
                        <button @click="toggle" class="button is-medium is-pulled-left">
                            {{ formatDate(deliveryInfo.deliveryDate) || 'Select date and time' }}
                        </button>
                        <a class="delete is-medium is-pulled-right" @click.prevent="deliveryDate = null" v-if="deliveryDate"></a>
                      </div>
                    </template>
                    </date-pick>
                  </p>
                  <p
                    class="help is-danger"
                    v-if="errors.deliveryDate"
                  >{{errors.deliveryDate.msg}}</p>
                </div>
              </div>
            </div>
          </template>
          <p class="help is-danger" v-if="errors.deliveryModes">{{errors.deliveryModes.msg}}</p>
          <hr v-if="!resourceId && paymentInfo" />
          <div v-if="!resourceId && paymentInfo" class="mt-5">
            <p class="title has-text-weight-medium">Pay with</p>
            <p class="buttons">
              <button
                class="button is-inverted"
                v-for="mode in paymentInfo"
                :key="mode.mid"
                :class="[ payment.mid === mode.mid? 'is-active is-focused is-info': '', mode.name === 'UPI'? 'is-hidden-tablet': '']"
                :disabled="isDisabled"
                @click="updatePayment(mode)"
              >
                <span v-if="payment.mid === mode.mid" class="icon is-small">
                  <font-awesome-icon icon="check" />
                </span>
                <span v-if="mode.mid === 'razorpay'">Cards/Others</span>
                <span v-else>{{ mode.name }}</span>
              </button>
            </p>
            <p class="help is-danger" v-if="errors.payment">{{errors.payment.msg}}</p>
          </div>
          <UiNotification
            v-if="errors.saleUIError"
            cls="is-danger"
            :HTMLmsg="errors.saleUIError.msg"
          ></UiNotification>
          <div class="field is-grouped is-grouped-centered pt-5">
            <p class="control">
              <button class="button is-medium" @click="goBack">
                <span class="icon is-small is-size-6">
                  <font-awesome-icon icon="chevron-left" />
                </span>
                <span class="is-size-6">Back</span>
              </button>
            </p>
            <p class="control">
              <button
                class="button is-medium is-primary"
                :class="[isLoading? 'is-loading': '']"
                :disabled="isDisabled"
                @click="submitForm"
              >
                <span class="is-size-6" v-if="resourceId">Confirm</span>
                <span
                  class="is-size-6"
                  v-else-if="payment.mid && payment.mid.toLowerCase() === `cash`"
                >Place Order</span>
                <span class="is-size-6" v-else>
                  Pay
                  <span class="ml-5" v-html="formatPrice(sale.billRoundedAmount)"></span>
                </span>
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as ObjectId from "bson-objectid";
import UiNotification from "@/views/common/Notification";
import AddressPicker from "@/components/ux/AddressPicker";
import DatePick from 'vue-date-pick';
import { mapState, mapGetters } from "vuex";
import Constants from "@/util/constants";
import Util from "@/util";
import 'vue-date-pick/dist/vueDatePick.css';

export default {
  name: "CustomerForm",
  components: {
    UiNotification,
    AddressPicker,
    DatePick
  },

  data() {
    return {
      disableCustomerPhoneNumber: false,
      customerInfo: {
        marketUserId: null,
        contactInfo: {
          name: {
            firstName: null,
            lastName: null
          },
          phoneNumber: null
        }
      },
      paymentStatusCodes: Constants.dataMap.paymentStatus,
      siteKey: "6Lfxjk0nAAAAAJev8l6Buz5UqQRKMD8PdBSn-3xc",
      errors: {},
      isLoading: false,
      isDisabled: false,
      payment: {},
      useCustomerContact: true,
      deliveryInfo: {
        id: null,
        label: null,
        mode: null,
        contactInfo: {
          name: {
            firstName: null,
            lastName: null
          },
          phoneNumber: null
        },
        address: null
      },
      deliveryDate: null
    };
  },

  computed: {
    ...mapState("cart", ["sale", "saleResponse", "paymentTxn", "saleError"]),
    ...mapState("business", [
      "business",
      "paymentInfo",
      "businessError",
      "resourceId",
      "features"
    ]),
    ...mapGetters("business", [
      "hasBothDeliveryModes",
      "deliveryModes",
      "deliveryModePreferences",
      "mapConfig",
      "businessContact",
      "isBizClosed"
    ]),
    saleObj() {
      const RL = window.RL;

      if (this.sale && RL) {
        try {
          return RL.bill.getDIV(this.sale);
        } catch (error) {
          console.log(error);
        }
      }
      return "No Sale.";
    },
    saleErrorMsg() {
      let contactText = this.businessContact
        ? `at ${this.businessContact}`
        : "";
      return `Please contact the outlet ${contactText} to place this order.`;
    },
    scheduledDeliveryHint() {
      const dTime = this.business.deliveryTime
      if (this.deliveryInfo.mode === Constants.dataMap.deliveryMode.DELIVERY) {
        return `Your order will be delivered within ${dTime} min. (or)`
      }
      return ''
    },

    deliveryModeLabel () {
      if (this.deliveryInfo.mode === Constants.dataMap.deliveryMode.PICKUP) {
        return Constants.dataMap.deliveryMode.PICKUP
      }
      return 'Deliver'
    }
  },

  mounted() {
    if (typeof Razorpay === "undefined") {
      let razorpayScript = document.createElement("script");
      razorpayScript.setAttribute(
        "src",
        "https://checkout.razorpay.com/v1/checkout.js"
      );
      razorpayScript.async = true;
      document.head.appendChild(razorpayScript);
    }
  },

  activated() {
    this.$store.dispatch("cart/resetSaleErrors");
    const deliveryInfo = this.$store.getters["cart/deliveryInfo"];
    this.deliveryInfo.mode = deliveryInfo.mode;

    this.disableCustomerPhoneNumber = false;

    this.user = this.$store.getters["user/user"];
    if (this.user) {
      this.disableCustomerPhoneNumber = true;
      this.customerInfo = Util.cloneObj(this.$store.getters["cart/customerInfo"]);
      this.deliveryInfo.contactInfo = {
        name: Util.cloneObj(this.customerInfo.contactInfo.name),
        phoneNumber: Util.cloneObj(this.customerInfo.contactInfo.phoneNumber)
      }
    }
  },

  watch: {
    saleError(err) {
      if (!err) {
        return;
      }
      Util.notify(this, {
        error: this.saleErrorMsg
      });
    },
    businessError(err) {
      if (!err) {
        return;
      }
      Util.notify(this, {
        message: "Outlet is closed for online ordering."
      });
    },
    "paymentTxn.errorMessage"(error) {
      const paymentTxn = this.paymentTxn;
      if (!error) {
        return;
      }
      if (
        paymentTxn &&
        paymentTxn.paymentStatus === this.paymentStatusCodes[2] &&
        paymentTxn.errorMessage
      ) {
        Util.notify(this, { error, sticky: true });
      }
    },
    deliveryDate (date) {
      const format = (dateStr) => {
        return Util.formatDate({ date: dateStr, zoneId: this.$store.getters['business/timeZone'].zoneId });
      }
      if (!date) {
        this.deliveryInfo.deliveryDate = null
        return
      }
      this.deliveryInfo.deliveryDate = format(date)
    }
  },

  methods: {
    submitForm() {
      const me = this;
      const name = this.customerInfo.contactInfo.name;
      let isDirty = false;

      if (this.user.firstName !== name.firstName || this.user.lastName !== name.lastName) {
        isDirty = true;
      }

      this.validateForm();
      if (Object.keys(this.errors).length === 0) {
        this.$store.dispatch("cart/updateSaleField", {
          field: 'customerInfo',
          value: this.customerInfo
        });
        this.isLoading = "is-loading";
        this.isDisabled = true;

        switch (this.deliveryInfo.mode) {
          case Constants.dataMap.deliveryMode.PICKUP:
            this.deliveryInfo.contactInfo = {
              name: Util.cloneObj(name),
              phoneNumber: Util.cloneObj(this.customerInfo.contactInfo.phoneNumber)
            };
            if (isDirty) {
              this.$store
                .dispatch("user/update", {
                  firstName: this.deliveryInfo.contactInfo.name.firstName,
                  lastName: this.deliveryInfo.contactInfo.name.lastName
                })
                .catch(Util.emptyFn);
            }
            break;
          case Constants.dataMap.deliveryMode.DELIVERY:
            const deliveryInfos = this.user.deliveryInfos || [];
            let params = {};

            if (!this.deliveryInfo.id) {
              this.deliveryInfo.id = ObjectId();
              deliveryInfos.push({
                id: this.deliveryInfo.id,
                label: this.deliveryInfo.label,
                contactInfo: this.deliveryInfo.contactInfo,
                address: this.deliveryInfo.address
              });
            } else {
              for (let i = 0; i < deliveryInfos.length; i++) {
                const deliveryInfo = deliveryInfos[i];
                if (this.deliveryInfo.id === deliveryInfo.id) {
                  deliveryInfo.label = this.deliveryInfo.label;
                  deliveryInfo.contactInfo = this.deliveryInfo.contactInfo;
                  deliveryInfo.address = this.deliveryInfo.address;
                  break;
                }
              }
            }
            params = { deliveryInfos };
            if (isDirty) {
              Object.assign(params, {
                firstName: name.firstName,
                lastName: name.lastName
              });
            }

            this.$store
              .dispatch("user/update", params)
              .catch(Util.emptyFn);
            break;
          default:
            this.deliveryInfo = {};
            if (isDirty) {
              this.$store
                .dispatch("user/update", {
                  firstName: name.firstName,
                  lastName: name.lastName
                })
                .catch(Util.emptyFn);
            }
            break;
        }
        this.$store.dispatch("cart/updateDeliveryInfo", this.deliveryInfo);

        if (!Util.isEmpty(this.payment) && this.payment.mid.toLowerCase() !== "cash") {
          this.$store.dispatch("cart/updatePaymentInfo", this.payment);
        }

        this.$store.dispatch("business/getOutlet").then(() => {
          if (this.businessError) {
              return;
            }

            this.$store.dispatch("cart/saveSale", {
              cb: err => {
                me.isLoading = false;
                me.isDisabled = false;
                if (!err) {
                  if (me.paymentTxn && me.paymentTxn.extras) {
                    this.invokePaymentProvider((err, res) => {
                      if (!err && res.checkStatus) {
                        me.displayOrderStatus();
                      }
                    });
                  } else if (!me.paymentTxn) {
                    me.displayOrderResult();
                  }
                }
              }
            });
        });
      } else {
        this.payment = {};
      }
    },

    validateForm() {
      let pref = {};
      const ignoreVal = !!this.resourceId;
      this.errors = {};

      if (!Util.isValidPhoneNumber(this.customerInfo.contactInfo.phoneNumber)) {
        this.errors["phoneNumber"] = {
          msg: "Please provide a valid phone number."
        };
      }

      if (Util.isEmpty(this.sale.saleItems)) {
        Util.notify(this, {
          error: 'No items in your cart. Please add items to proceed.'
        });

        this.errors["saleItems"] = {
          msg: 'Empty cart.'
        };
      }

      if (
        Util.isEmpty(this.customerInfo.contactInfo.name.firstName) ||
        !Util.isValidName(this.customerInfo.contactInfo.name.firstName)
      ) {
        this.errors["firstName"] = {
          msg: "Please provide a valid first name."
        };
      }

      if (ignoreVal) {
        return;
      }

      if (
        !Util.isEmpty(this.customerInfo.contactInfo.name.lastName) &&
        !Util.isValidName(this.customerInfo.contactInfo.name.lastName)
      ) {
        this.errors["lastName"] = {
          msg: "Please provide a valid last name."
        };
      }

      if (Util.isEmpty(this.payment)) {
        this.errors["payment"] = {
          msg: "Please select mode of payment."
        };
      }

      if (this.deliveryInfo.mode) {
        pref = this.deliveryModePreferences(this.deliveryInfo.mode);
        if (this.deliveryInfo.mode === Constants.dataMap.deliveryMode.DELIVERY) {
          if (Util.isEmpty(this.deliveryInfo.label)) {
            this.errors.deliveryInfoLabel = {
              msg: "Please add a label to your delivery address"
            };
          }

          if (
            Util.isEmpty(this.deliveryInfo.contactInfo.name.firstName) ||
            !Util.isValidName(this.deliveryInfo.contactInfo.name.firstName)
          ) {
            this.errors.deliveryInfoFirstName = {
              msg: "Please provide a valid contact first name."
            };
          }

          if (
            !Util.isEmpty(this.deliveryInfo.contactInfo.name.lastName) &&
            !Util.isValidName(this.deliveryInfo.contactInfo.name.lastName)
          ) {
            this.errors.deliveryInfoLastName = {
              msg: "Please provide a valid contact last name."
            };
          }

          if (
            !Util.isValidPhoneNumber(this.deliveryInfo.contactInfo.phoneNumber)
          ) {
            this.errors.deliveryInfoPhoneNumber = {
              msg: "Please provide a valid contact phone number."
            };
          }

          if (
            Util.isEmpty(this.deliveryInfo.address) ||
            Util.isEmpty(this.deliveryInfo.address.geolocation)
          ) {
            this.errors["deliveryModes"] = {
              msg: "Please provide a delivery address."
            };
          }
        }
        if (this.isBizClosed && this.features.allowPreOrder && !this.deliveryInfo.deliveryDate) {
          this.errors["deliveryDate"] = {
            msg: "Schedule your order."
          };
        }
        if (this.deliveryInfo.deliveryDate && !this.$store.getters['business/isOrderedInBizHours'](this.deliveryInfo.deliveryDate)) {
          this.errors["deliveryDate"] = {
            msg: "Please schedule order with in operational hours."
          };
        }
        if (
          pref &&
          pref.minBillAmount &&
          this.sale.billRoundedAmount < pref.minBillAmount
        ) {
          this.errors["saleUIError"] = {
            msg: `Minimum order amount of ${this.formatPrice(
              pref.minBillAmount
            )} is required for ${this.deliveryInfo.mode}.`
          };
        }
      }

      if (!Util.isValidPhoneNumber(this.customerInfo.contactInfo.phoneNumber)) {
        this.errors["phoneNumber"] = {
          msg: "A valid phone number is required."
        };
      }
    },

    formatPrice(number) {
      if (isNaN(number)) {
        return "";
      }
      const curr = Constants.currency[this.$store.getters["business/currency"]];

      return [curr, Util.insertDecimalPoints(number)].join(" ");
    },

    restart() {
      this.$router.go(-1);
    },

    updatePayment(mode) {
      this.payment = mode;
    },

    goBack() {
      this.$router.go(-1);
    },

    invokePaymentProvider(cb) {
      const paymentTxn = this.paymentTxn;
      if (paymentTxn.extras.redirectURL) {
        window.open(this.paymentTxn.extras.redirectURL, "_parent");
        return cb(null, { checkStatus: true });
      }

      if (paymentTxn.extras.mid === "razorpay") {
        const options = {
          redirect: false,
          key: paymentTxn.extras.apiKey,
          amount: parseInt(paymentTxn.requestAmount * 100, 10),
          currency: this.sale.currency,
          name: this.business.brandName,
          description: `Order #${this.saleResponse.billNumber}`,
          image: `${process.env.VUE_APP_IMG_URL}/logo/${this.business.logoId}/large`,
          order_id: paymentTxn.transactionId,
          prefill: {
            name: this.customerInfo.contactInfo.firstName,
            contact: this.customerInfo.contactInfo.phoneNumber
          },
          handler: response => {
            const payment = {
              paymentId: paymentTxn.paymentId,
              pid: paymentTxn.pid,
              data: response
            };
            this.$store.dispatch("cart/verifyAndPostPayment", {
              payment,
              callback: () => {
                return cb(null, { checkStatus: true });
              }
            });
          },
          modal: {
            ondismiss: () => {
              const payment = {
                paymentId: paymentTxn.paymentId,
                pid: paymentTxn.pid,
                data: {
                  error: {
                    code: "USER_CANCELLED"
                  }
                }
              };
              this.$store.dispatch("cart/verifyAndPostPayment", {
                payment,
                callback: () => {
                  return cb(null, { checkStatus: true });
                }
              });
            }
          }
        };
        const razorpayInstance = new window.Razorpay(options);
        razorpayInstance.open();
      }
    },

    displayOrderStatus() {
      this.$router.push({ name: "OutletOrderStatus" });
    },

    displayOrderResult() {
      this.$router.push({ name: "OutletOrderResult" });
    },

    onDeliveryAddressChange(address) {
      this.deliveryInfo.address = address;
    },

    copyContactInfo(event) {
      if (event.target.checked) {
        this.useCustomerContact = true;
        this.deliveryInfo.contactInfo = Object.assign({}, {
          name: {
            firstName: this.user.firstName || this.customerInfo.contactInfo.name.firstName,
            lastName: this.user.lastName || this.customerInfo.contactInfo.name.lastName
          },
          phoneNumber: this.user.phoneNumber || this.customerInfo.contactInfo.phoneNumber
        });
      } else {
        this.useCustomerContact = false;
        this.deliveryInfo.contactInfo.name.firstName = null;
        this.deliveryInfo.contactInfo.name.lastName = null;
        this.deliveryInfo.contactInfo.phoneNumber = null;
      }
    },

    onDeliveryInfoLabelChange(event) {
      const deliveryInfoId = event.target.value;
      this.useCustomerContact = false;
      if (Util.isEmpty(deliveryInfoId)) {
        this.deliveryInfo.id = null;
        this.deliveryInfo.label = null;
        this.deliveryInfo.contactInfo.name.firstName = null;
        this.deliveryInfo.contactInfo.name.lastName = null;
        this.deliveryInfo.contactInfo.phoneNumber = null;
        this.deliveryInfo.address = null;
        return;
      }

      const deliveryInfos = this.user.deliveryInfos;
      let savedDeliveryInfo;
      for (let i = 0; i < deliveryInfos.length; i++) {
        savedDeliveryInfo = Object.assign({}, deliveryInfos[i]);
        if (savedDeliveryInfo.id === deliveryInfoId) {
          break;
        }
      }
      if (savedDeliveryInfo) {
        this.deliveryInfo.id = savedDeliveryInfo.id;
        this.deliveryInfo.label = savedDeliveryInfo.label;
        this.deliveryInfo.contactInfo.name.firstName =
          savedDeliveryInfo.contactInfo.name.firstName;
        this.deliveryInfo.contactInfo.name.lastName =
          savedDeliveryInfo.contactInfo.name.lastName;
        this.deliveryInfo.contactInfo.phoneNumber =
          savedDeliveryInfo.contactInfo.phoneNumber;
        this.deliveryInfo.address = savedDeliveryInfo.address;
      }
    },

    isPastDate(date) {
      const currentDate = new Date();
      return date < currentDate.setDate(currentDate.getDate() - 1);
    },

    formatDate(date) {
      if (!date) {
        return null
      }
      return Util.formatDate({ date: date, pattern: 'do LLL p' })
    }
  }
};
</script>
